import { render, staticRenderFns } from "./PlSalesStatisticTabs.vue?vue&type=template&id=01dc1fc8&scoped=true"
import script from "./PlSalesStatisticTabs.vue?vue&type=script&lang=js"
export * from "./PlSalesStatisticTabs.vue?vue&type=script&lang=js"
import style0 from "./PlSalesStatisticTabs.vue?vue&type=style&index=0&id=01dc1fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc1fc8",
  null
  
)

export default component.exports